import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import { useSelector } from "react-redux";
import { selectors as headerSelector, selectors as imgSelector } from '../../../state/features/header';
import './index.scss'
import helperfunctions from '../../../utils/helperfunctions';
import partsService from "../../../services/partsservice";
import MaintenancePartListExcelExport from '../../ShoppingCart/MaintenancePartList/maintenancepartlistexcelexport';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import PartDropDownList from '../../MachineDetails/MyHealth/MaintanceRecommendation/partdropdownlist';
import { QuestionMark } from '../../../assets/images';
import Loader from '../../Loader';

interface Ipros {
    data: any,
    getCartItems: any,
    partNumberRedirect: any,
    setMaintenancePartsList: any,
    maintenancePartsList: any,
    onRefresh: any
    getMiningParts?: any
}

const MaintenancePartAccordian = (props: Ipros) => {
    const { t } = useTranslation();
    const { imgBaseUrlSelectors }: any = useSelector((state) => ({
        imgBaseUrlSelectors: imgSelector.imgbaseUrl(state),
    }));
    const imgUrl = imgBaseUrlSelectors;
    const [isActive, setIsActive] = useState(false);
    const [selectedMasterId, setSelectedMasterId] = useState<any>(null);
    const [isAddingParts, setIsAddingParts] = useState(false)
    const partNoRefs = useRef<any[]>([]);
    const [invalidPartIndices, setInvalidPartIndices] = useState<number[]>([]);
    const [firstInvalidPartIndex, setfirstInvalidPartIndex] = useState<any>(null);
    
    const { globalData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
    }));

    const { headercurrentuser }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
        }));

    const _maintenancePartExport = React.createRef<ExcelExport>();
    const excelExportMaintenancePart = () => {
        if (_maintenancePartExport.current) {
            _maintenancePartExport.current.save();
        }
    };
    const handleOpen = () => {
        setIsActive(!isActive)
    };

    const addPartNumber = (parts: any ,item:any, data: any) => {
        if ((globalData?.BranchCode ?? "") != "" && (globalData?.DistributorCode ?? "") != "") {
            addPartNumberFromMaintenance(parts,item, data);
        }
        else {
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_SC_Select_Ordering_Branch))
        }
    }

    const resetPartsList = (item: any, data: any) => {
        const updatedData = props?.maintenancePartsList?.map((t: any) => {
            if (t?.model == data?.model && t?.serial == data?.serial && t?.unit == data?.unit) {
                t.maintenanceRecommendedList?.forEach((x: any) => {
                    if ((item && (x?.masterID == item?.masterID) && item?.isSelect) || (!item && x?.isSelect)) {
                        x.quantity = 0;
                        x.partNo = 'Select';
                        x.isSelect = false;
                    }
                    else
                        return x;
                })
                return t;
            }
            else
                return t;
        })
        setSelectedMasterId(null);
        props?.setMaintenancePartsList(updatedData);
    }

    const addPartNumberFromMaintenance = (parts: any,item:any, data: any) => {
        setIsAddingParts(true);
        const model = {
            cart: {
                PunchoutOrderRequestId: globalData?.punchOutRequestPartLogId ?? 0,
                userAadId: headercurrentuser?.azureADId,
                distributorCode: globalData.DistributorCode,
                branchCode: globalData.BranchCode,
                customerId: globalData.CustomerId ? parseInt(globalData.CustomerId) : 0,
                locationId: globalData.LocationId ? parseInt(globalData.LocationId) : 0
            },
            parts: parts
        };

        partsService.addPartNumber(model)
            .then((response: any) => {
                setIsAddingParts(false)
                if (response.isSuccessful) {
                    props?.getMiningParts();
                    helperfunctions.showSuccessMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Success_Msg));
                    props.onRefresh(null, true);
                    resetPartsList(item, data);
                }
                else
                    helperfunctions.showErrorMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Error_Msg));
            })
            .catch((e: any) => {
                setIsAddingParts(false)
                helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Error_Msg));
            });
    }

    const addPartNumberIndividual = (part: any, maintenanceRecommendation: any, index: any) => {
        const partsModel =
            [
                {
                    manufacturer: {
                        code: part?.manufacturerCode,
                        name: part?.manufacturer
                    },
                    partNumber: part?.partNo,
                    quantity: part?.quantity,
                    machine: {
                        mDbId: part?.machineId,
                        model: maintenanceRecommendation?.model,
                        serial: maintenanceRecommendation?.serial,
                        unitNumber: maintenanceRecommendation?.unit
                    }
                }
            ]
        if (part?.partNo == "" || part?.partNo == null || part?.partNo?.toLowerCase() == "select") {
            partNoRefs.current[index]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            partNoRefs.current[index]?.classList.add('highlight');
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Select_Part_Number));
        }
        else if (part?.manufacturer == "" || part?.manufacturer == null) {
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Manufacture_Required));
        }
        else if (part?.quantity < 1 || part?.quantity > 9999) {
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Quantity_Validation));
        }
        else {
            addPartNumber(partsModel, part, maintenanceRecommendation);
        }
    }

    useEffect(() => {
        if (isActive && invalidPartIndices.length > 0) {
            invalidPartIndices.forEach(index => {
                partNoRefs.current[index]?.classList.add('highlight');
            });
            partNoRefs.current[firstInvalidPartIndex]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setfirstInvalidPartIndex(null);
            setInvalidPartIndices([]);
        }
    }, [isActive, invalidPartIndices]);
  
    const addPartNumberBulk = (maintenanceRecommendation: any) => {
        const partsModel = maintenanceRecommendation?.maintenanceRecommendedList?.map((part: any) => {
            return {
                manufacturer: {
                    code: part?.manufacturerCode,
                    name: part?.manufacturer
                },
                partNumber: part?.partNo,
                quantity: part?.quantity,
                machine: {
                    mDbId: part?.machineId,
                    model: maintenanceRecommendation?.model,
                    serial: maintenanceRecommendation?.serial,
                    unitNumber: maintenanceRecommendation?.unit
                }
            }
        })
        let isPartNoNotValid = partsModel?.filter((s: any) => s.partNumber == null || s.partNumber == "" || s.partNumber?.toLowerCase() == "select")?.length > 0;
        let isQuantityNotValid = partsModel?.filter((s: any) => s.quantity < 0 || s.quantity > 9999)?.length > 0;
        let isManufactureNotValid = partsModel?.filter((s: any) => s.manufacturer?.code == "" || s.manufacturer?.code == null)?.length > 0;
        const invalidPartIndices = partsModel
            .map((s: any, index: number) => (s.partNumber == null || s.partNumber == "" || s.partNumber?.toLowerCase() == "select" ? index : -1))
            .filter((index: any) => index !== -1);

        const firstInvalidPartIndex = invalidPartIndices[0];

        setfirstInvalidPartIndex(firstInvalidPartIndex);
        setInvalidPartIndices(invalidPartIndices);
        if (isPartNoNotValid) {
            setIsActive(true);
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Select_Part_Number));
        }
        else if (isManufactureNotValid) {
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Manufacture_Required));
        }
        else if (isQuantityNotValid) {
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Quantity_Validation));
        }
        else {
            addPartNumber(partsModel, null, maintenanceRecommendation);
        }
    }

    const onChange = (event: any, item: any, data: any, index: any) => {
        partNoRefs.current[index]?.classList.remove('highlight');
        const updatedData = props?.maintenancePartsList?.map((t: any) => {
            if (t?.model == data?.model && t?.serial == data?.serial && t?.unit == data?.unit) {
                t.maintenanceRecommendedList?.forEach((x: any) => {
                    if (x?.masterID == item.masterID) {
                        x.quantity = event.quantity;
                        x.partNo = event.value;
                        x.isSelect = true;
                    }
                    else
                        return x;
                })
                return t;
            }
            else
                return t;
        })
        setSelectedMasterId(event?.masterID);
        props?.setMaintenancePartsList(updatedData)
    }
    return (
        <>
            <div className="custom-Accordion-base">
                {isAddingParts && <Loader/>}
                <div className={`custom-Accordion-title ${isActive ? 'accordian-open' : 'accordian-close'}`}>
                    <span>
                        <span className="maintenanceView">
                            <span className="maintenanceView_title" onClick={handleOpen} onKeyDown={() => { }}>
                                {props?.data?.serviceIntervalHours} {t(RESOURCE.MyK_Label_Model)} : {props?.data?.model} {t(RESOURCE.MyK_Label_Serial) + ' #'} : {props?.data?.serial} {t(RESOURCE.MyK_Label_Unit) + ' #'} : {props?.data?.unit}
                            </span>
                            <span className="maintenanceButton">
                                <button className="exportBtn mr-2 mb-md-2 mb-lg-2 mb-xl-0" title={t(RESOURCE.MyK_HealthLabel_CPT_ACC_Export)} onClick={() => excelExportMaintenancePart()}>{t(RESOURCE.MyK_HealthLabel_CPT_ACC_Export)}</button>
                                <button className="addCartBtn mr-4" title={t(RESOURCE.MyK_Label_AddToCartList)} onClick={() => addPartNumberBulk(props?.data)}>{t(RESOURCE.MyK_Label_AddToCartList)}</button>

                            </span>
                            <span className={`expand_colapse ${isActive ? 'minus' : 'plus'}`} onClick={handleOpen} onKeyDown={() => { }} title={t(RESOURCE.MyK_Label_ShoppingCart_Expand_Collapse)}> {isActive ? "-" : "+"}
                            </span>
                        </span>
                    </span>

                </div>
                {isActive && <div className="custom-Accordion-content">
                    <table className="maintenancetable">
                        <tr className="maintenancepartListWrapper header">
                            <td className="partnumbber header" title={t(RESOURCE.MyK_Grid_Part_Number)}>{t(RESOURCE.MyK_Grid_Part_Number)}</td>
                            <td className="partdesc header" title={t(RESOURCE.MyK_Grid_Part_Name)}>{t(RESOURCE.MyK_Grid_Part_Name)}</td>
                            <td className="manufacturername header" title={t(RESOURCE.MyK_Label_ManufacturerName)}>{t(RESOURCE.MyK_Label_ManufacturerName)}</td>
                            <td className="recommendedquant header" title={t(RESOURCE.MyK_Grid_Reccomend_Quantity)}>{t(RESOURCE.MyK_Grid_Reccomend_Quantity)}</td>
                            <td className="addtocartHeader header" title={t(RESOURCE.MyK_Label_AddToCart)}>{t(RESOURCE.MyK_Label_AddToCart)}</td>

                        </tr>
                        {props?.data?.maintenanceRecommendedList?.map((item: any, index:any) => (

                            <tr className="maintenancepartListWrapper" key={item.masterId}
                                ref={(el) => (partNoRefs.current[index] = el)}
                            >
                                {item.isDropDown ?
                                    selectedMasterId == item.masterID ?
                                        (<td className="partnumbber-ddl">
                                            <PartDropDownList partNo={item.partNo} model={props?.data?.model} recommendationParts={item.recommendationParts} masterId={item.masterID} onChange={(event: any) => onChange(event, item, props?.data, index)}></PartDropDownList>
                                        </td>) :
                                        (<td className="partnumbber" onClick={() => setSelectedMasterId(item.masterID)} title={item.partNo}>
                                            {(item.isOptional == 1) && <img src={imgUrl + QuestionMark} className="optional-part-icon" title={t(RESOURCE.MyK_HealthLabel_Optional_Part)} />}
                                            {item.partNo?.toLowerCase() != "select" && <span className="selected-part"></span>}{item.partNo}
                                        </td>)
                                    : <td className="partnumbber" onClick={() => props.partNumberRedirect(item.partNo)} title={item.partNo}>
                                        {(item.isOptional == 1) && <img src={imgUrl + QuestionMark} className="optional-part-icon" title={t(RESOURCE.MyK_HealthLabel_Optional_Part)} />}
                                        {item.partNo}</td>
                                }
                                <td className="partdesc" title={item.recommendationParts}>{item.recommendationParts}</td>
                                <td className="manufacturername" title={item.manufacturer}>{item.manufacturer}</td>
                                <td className="recommendedquant" title={item.quantity}>{item.quantity}</td>
                                <td className="addtocart" title={t(RESOURCE.MyK_Label_AddToCart)} onClick={() => addPartNumberIndividual(item, props?.data, index)}>{t(RESOURCE.MyK_Label_AddToCart)}</td>
                            </tr>
                        ))}
                    </table>
                </div>}
            </div>

            <MaintenancePartListExcelExport maintentenaceRecommendationParts={props?.data} _maintenancePartExport={_maintenancePartExport} />
        </>
    )
}

export default MaintenancePartAccordian;
